webpackJsonp([173894859265406],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(7);
	
	__webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-multi-comp: 0, react/prop-types: 0 */
	
	var ModalExample = function (_React$Component) {
	  _inherits(ModalExample, _React$Component);
	
	  function ModalExample(props) {
	    _classCallCheck(this, ModalExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      modal: false
	    };
	
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  ModalExample.prototype.toggle = function toggle() {
	    this.setState({
	      modal: !this.state.modal
	    });
	  };
	
	  ModalExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'button',
	        { className: this.props.buttonClassName, onClick: this.toggle },
	        this.props.buttonLabel
	      ),
	      _react2.default.createElement(
	        _reactstrap.Modal,
	        { isOpen: this.state.modal, toggle: this.toggle, className: 'video-modal' },
	        _react2.default.createElement(
	          _reactstrap.ModalBody,
	          { className: 'p-1 video-modal-body' },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          _reactstrap.ModalFooter,
	          { className: 'video-modal-footer pr-3 pb-3 pt-1' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'text-light mr-auto' },
	            this.props.title
	          ),
	          _react2.default.createElement(
	            _reactstrap.Button,
	            { color: 'danger', onClick: this.toggle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close' })
	          )
	        )
	      )
	    );
	  };
	
	  return ModalExample;
	}(_react2.default.Component);
	
	exports.default = ModalExample;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 951:
/***/ (function(module, exports) {

	module.exports = {"educators":{"title":"Teach","subtitle":"Teach your students","slug":"/teach"},"learn":{"title":"Learn","subtitle":"Try OcuChess to reach your max potential!","slug":"/learn"},"getInvolved":{"title":"Get Involved","subtitle":"Support Chess and cognitive learning","slug":"/help-us"}}

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

	module.exports = {"personalized":{"title":"Personalized","subtitle":"Tailor made for you! Goal that you reach your full potential!","slug":"/methods/personalized"},"grandmaster":{"title":"Grandmaster","subtitle":"USCF 2650 FIDE Senior Trainer Top level chess training","slug":"/competency"},"adaptive":{"title":"Adaptive","subtitle":"State of the art eye tracking and facial expressions analysis","slug":"/methods/biometrics"},"patterns":{"title":"Patterns","subtitle":"Novel pattern based method. Become an Expert!","slug":"/methods/patterns"},"science":{"title":"Science","subtitle":"International team of University professors","slug":"/cognitive-improvement"}}

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	module.exports = {"title":"SciChess","headline":"Where Chess meets Science!","startLearning":"Start Learning","watchVideo":"Watch the video"}

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeLayout = __webpack_require__(174);
	
	var _homeLayout2 = _interopRequireDefault(_homeLayout);
	
	var _jumbotron = __webpack_require__(953);
	
	var _jumbotron2 = _interopRequireDefault(_jumbotron);
	
	var _cards = __webpack_require__(951);
	
	var _cards2 = _interopRequireDefault(_cards);
	
	var _facts = __webpack_require__(952);
	
	var _facts2 = _interopRequireDefault(_facts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_homeLayout2.default, _extends({ cardsData: _cards2.default, factsData: _facts2.default, jumbotronData: _jumbotron2.default }, props));
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(props) {
	
	  return _react2.default.createElement(
	    _Link2.default,
	    { to: props.slug },
	    _react2.default.createElement(
	      'div',
	      { className: 'home-card rounded shadow' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: props.image, backgroundColor: 'rgba(0,255,0,0.4)', className: 'home-card-image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'home-card-labels-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'home-card-labels' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            props.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            props.subtitle
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(246);
	
	var _reactstrap = __webpack_require__(9);
	
	var _homeCard = __webpack_require__(169);
	
	var _homeCard2 = _interopRequireDefault(_homeCard);
	
	__webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    var cardsData = props.cardsData;
	    var educators = cardsData.educators;
	    var learn = cardsData.learn;
	    var getInvolved = cardsData.getInvolved;
	
	
	    return _react2.default.createElement(
	        _reactstrap.Row,
	        { className: 'justify-content-center mb-5' },
	        _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: '12', md: '6', lg: '4', className: 'my-2 align-self-center' },
	            _react2.default.createElement(_homeCard2.default, { title: educators.title, subtitle: educators.subtitle, image: props.images.educators, slug: educators.slug })
	        ),
	        _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: '12', md: '6', lg: '4', className: 'my-2 align-self-center' },
	            _react2.default.createElement(_homeCard2.default, { title: learn.title, subtitle: learn.subtitle, image: props.images.learn, slug: learn.slug })
	        ),
	        _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: '12', md: '6', lg: '4', className: 'my-2 align-self-center' },
	            _react2.default.createElement(_homeCard2.default, { title: getInvolved.title, subtitle: getInvolved.subtitle, image: props.images.getInvolved, slug: getInvolved.slug })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'home-fact' },
	    _react2.default.createElement(
	      _Link2.default,
	      { to: props.path },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h3 text-color-title' },
	          props.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'text-color-subtitle' },
	          props.text
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(9);
	
	var _homeFact = __webpack_require__(171);
	
	var _homeFact2 = _interopRequireDefault(_homeFact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var _props$factsData = props.factsData,
	      adaptive = _props$factsData.adaptive,
	      grandmaster = _props$factsData.grandmaster,
	      patterns = _props$factsData.patterns,
	      personalized = _props$factsData.personalized,
	      science = _props$factsData.science;
	
	  return _react2.default.createElement(
	    _reactstrap.Row,
	    { className: 'my-3' },
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { className: 'my-3' },
	      _react2.default.createElement(_homeFact2.default, {
	        path: personalized.slug,
	        title: personalized.title,
	        text: personalized.subtitle
	      })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { className: 'my-3' },
	      _react2.default.createElement(_homeFact2.default, {
	        path: patterns.slug,
	        title: patterns.title,
	        text: patterns.subtitle
	      })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { className: 'my-3' },
	      _react2.default.createElement(_homeFact2.default, {
	        path: grandmaster.slug,
	        title: grandmaster.title,
	        text: grandmaster.subtitle
	      })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { className: 'my-3' },
	      _react2.default.createElement(_homeFact2.default, {
	        path: science.slug,
	        title: science.title,
	        text: science.subtitle
	      })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Col,
	      { className: 'my-3' },
	      _react2.default.createElement(_homeFact2.default, {
	        path: adaptive.slug,
	        title: adaptive.title,
	        text: adaptive.subtitle
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(7);
	
	var _VideoModal = __webpack_require__(151);
	
	var _VideoModal2 = _interopRequireDefault(_VideoModal);
	
	var _reactYoutube = __webpack_require__(144);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	__webpack_require__(249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeJumbotron = function HomeJumbotron(props) {
	    var title = props.jumbotronData.title;
	    var headline = props.jumbotronData.headline;
	    var startLearning = props.jumbotronData.startLearning;
	    var watchVideo = props.jumbotronData.watchVideo;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'home-jumbotron' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: props.image, backgroundColor: 'rgba(51,102,255,0.4)', className: 'cover-image' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'jumbotron-title' },
	            _react2.default.createElement(
	                'h1',
	                { className: 'bold text-center' },
	                title
	            ),
	            _react2.default.createElement(
	                'h5',
	                { className: 'text-center' },
	                headline
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'jumbotron-button-group' },
	            _react2.default.createElement(
	                _Link2.default,
	                { to: '/learn', className: 'h5 text-center btn-cto' },
	                _react2.default.createElement('i', { className: 'fa fa-graduation-cap' }),
	                ' ',
	                startLearning
	            ),
	            _react2.default.createElement(
	                _VideoModal2.default,
	                { buttonClassName: 'h5 text-center btn-cto w-100', buttonLabel: watchVideo, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'introVideo' }) },
	                _react2.default.createElement(_reactYoutube2.default, { videoId: 'oEYkgUuBSE0', className: 'w-100 p-0', opts: { height: 500, playerVars: { autoplay: 1 } } })
	            )
	        )
	    );
	};
	
	exports.default = HomeJumbotron;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeJumbotron = __webpack_require__(173);
	
	var _homeJumbotron2 = _interopRequireDefault(_homeJumbotron);
	
	var _homeCardList = __webpack_require__(170);
	
	var _homeCardList2 = _interopRequireDefault(_homeCardList);
	
	var _homeFactList = __webpack_require__(172);
	
	var _homeFactList2 = _interopRequireDefault(_homeFactList);
	
	__webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    var factsData = props.factsData,
	        cardsData = props.cardsData,
	        jumbotronData = props.jumbotronData;
	
	    var jumbotronImg = props.data.jumbotronImg.childImageSharp.sizes;
	    var cardsImages = {
	        educators: props.data.cardEducatorImg.childImageSharp.sizes,
	        learn: props.data.cardLearnImg.childImageSharp.sizes,
	        getInvolved: props.data.cardGetInvolvedImg.childImageSharp.sizes
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'wrapper' },
	            _react2.default.createElement(_homeJumbotron2.default, { jumbotronData: jumbotronData, image: jumbotronImg })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(_homeFactList2.default, { factsData: factsData }),
	            _react2.default.createElement(_homeCardList2.default, { cardsData: cardsData, images: cardsImages })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-en-js-64be358b64fa54a7a43b.js